<template>
    <div class="row tablaConTexto">
        <table class="table table-striped table-hover table-bordered mt-4">
            <thead class="thead-green">
                <th class="titulo text-center" v-for="titulo in seccionDeLaPaginaWeb.Titulo.split('¶')" v-bind:key="titulo">{{titulo}}</th>
            </thead>
            <tbody>
                <tr v-for="contenidoDeLaPaginaWeb in seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb" v-bind:key="contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId">
                    <td class="text-justify" v-for="contenido in contenidoDeLaPaginaWeb.TextoDelContenido.split('¶')" v-bind:key="contenido">{{contenido}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        seccionDeLaPaginaWeb: Object
    }
}
</script>

<style scoped>
.thead-green{
    background-color: var(--verde-pj) !important;
    color: white;
}
  .tablaConTexto .titulo {
    font-size: 1em;
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Formatos/TablaConTexto.vue